import React, { useEffect, useCallback, useState, useRef, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import Modal from "components/common/modal";
import { livefeedStyle } from "components/pages/livefeed/defaultstate";
import * as a from "actions/livefeedapi";
import update from "immutability-helper";
import { setLivefeedName } from "actions/livefeed";
import { generateSlideName } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import Select from 'react-select';
import './index.less'

const TemplateModal = forwardRef((props, ref) => {
    // passedProps
    const {
        router, editorMode, editorKey, savingType, creatorEmail,
        dispatch, livefeedSlides, livefeedName, isCreateMode
    } = props;
    const templateModal = useRef(null);
    const [templateOptions, setTemplateOptions] = useState([])
    const [chosenTemplate, setChosenTemplate] = useState()

    useEffect(
        () => {
            const templateOptions = livefeedSlides.map((slide, index) => {
                return ({ label: generateSlideName(livefeedSlides, slide), value: index })
            })
            setTemplateOptions(templateOptions)
            setChosenTemplate(templateOptions)
        }, [livefeedSlides])

    useImperativeHandle(ref, () => ({
        open: () => {
            templateModal.current.open()
        }
    }));

    //-------------------------------------------Function create schema before submit -----------------------------------
    const createTemplateSchema = useCallback(
        () => {
            let processedTemplate = []
            for (let i = 0; i < chosenTemplate.length; i++) {
                processedTemplate.push(livefeedSlides[chosenTemplate[i].value]) // save only chosen index slides
                processedTemplate = update(processedTemplate, {
                    [[i]]: {
                        // clear historyEntities on every slide
                        historyEntities: {
                            $set: [
                                {
                                    id: null
                                }
                            ]
                        },
                        logoState: {
                            file: { $set: null }
                        }
                    }
                });
            }
            return processedTemplate // array of an object
        },
        [livefeedSlides, chosenTemplate]
    );

    //------------------------------------------------------ SUBMIT TEMPLATE -------------------------
    const submitTemplate = useCallback(
        () => {
            if (livefeedName) {
                let newTemplate = {
                    name: livefeedName,
                    owner: creatorEmail,
                    data: {
                        owner: creatorEmail,
                        timestamp: Date.now(),
                        containerHeight: livefeedStyle.containerHeight,
                        containerWidth: livefeedStyle.containerWidth,
                        // save chosen slide or save all
                        livefeedSlides: createTemplateSchema()  // array of an object
                    }
                };
                //-------------------------- create dispatch -------------------------
                // in case editorMode is createLivefeed, but user choose to save as template
                if (
                    editorMode === "createTemplate" ||
                    editorMode === "createLivefeed" ||
                    // in case user edits template, but then  choose to save as a new template
                    savingType === "template"
                ) {
                    dispatch(
                        a.createTemplate(newTemplate, () => {
                            templateModal.current.close();
                            router.push({
                                pathname: "/livefeed"
                            });
                        })
                    );  /**/
                }
                //-------------------------- editor dispatch (AKA update) -------------------------
                else if (editorMode === "editTemplate" && savingType === "update") {
                    newTemplate.key = editorKey;
                    dispatch(
                        a.updateTemplate(newTemplate, () => {
                            templateModal.current.close();
                            router.push({
                                pathname: "/livefeed"
                            });
                        })
                    );
                }
            }
        },
        [createTemplateSchema, creatorEmail, dispatch, editorKey, editorMode, livefeedName, router, savingType]
    );

    const liveFeedNameChangeHandler = useCallback(
        e => {
            var name = e.target.value;
            dispatch(setLivefeedName(name));
        },
        [dispatch]
    );
    const isTemplateSubmittable = livefeedName;


    return (

        < Modal
            ref={templateModal}
            clickButton={() => (isTemplateSubmittable ? submitTemplate() : null)}
            header={`${isCreateMode ? "Save as Template" : "Update Template"}`}
            buttonText={`${isCreateMode ? "Save" : "Confirm"}`}
            buttonClass={isTemplateSubmittable ? "btn-success" : "btn-success disabled"}
            entry={null}
        >
            <div className="save-form">
                <div>
                    <span className="input-label">Template name:</span>
                    <input
                        type="text"
                        id="name"
                        value={livefeedName}
                        onChange={e => {
                            liveFeedNameChangeHandler(e);
                        }}
                        required
                    />
                </div>
                <p>Choose desired slides below to be saved</p>
                <div data-tooltip="Chosen template" className={`reactSelect-dropdown-wrapper`} >
                    <Select
                        className="reactSelect-template-layout"
                        options={templateOptions}
                        onChange={(slide) => setChosenTemplate(slide)}
                        value={chosenTemplate}
                        openOnClick={true}
                        closeOnSelect={true}
                        multi
                        removeSelected={true}
                    />
                </div>
                <div>
                    <span className="save-note good">Your Template is ready to be {isCreateMode ? "created" : "updated"}:</span>
                </div>
            </div>
        </Modal >
    );
});

TemplateModal.propTypes = {
    router: PropTypes.object.isRequired,
    editorMode: PropTypes.string,
    editorKey: PropTypes.any,
    savingType: PropTypes.string.isRequired,
    creatorEmail: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    livefeedSlides: PropTypes.array.isRequired,
    livefeedName: PropTypes.string.isRequired
};

export default TemplateModal;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/TemplateModal/index.jsx